import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import * as api from "@/services/api";
export const Status = {
  IDLE: "Idle",
  FETCHING: "Fetching",
  FOUND: "Found",
  FAILED: "Failed",
};

export const SORT = {
  STATUS: 0,
  ASC: 1,
  DESC: 2,
};

const initialState = {
  status: Status.IDLE,
  announcements: [],
  deatilsFilters: {
    region: {},
    cities: [],
    statuses: [],
    beneficiaries: [],
    outgoings: [],
    sectors: [],
  },
  sortFilter: SORT.STATUS,
};

export const searchAnnouncements = createAsyncThunk(
  "config/searchAnnouncements",
  async (filters) => {
    const announcementResponse = await api.search(
      `/announcement_filtered`,
      filters
    );
    return {
      announcementResponse,
    };
  }
);

export const fetchAnnouncements = createAsyncThunk(
  "config/fetchAnnouncements",
  async () => {
    //const [services] = await Promise.all([api.find(`/services`)]);
    const announcementResponse = await api.find(`/announcement`);
    return {
      announcementResponse,
    };
  }
);

const slice = createSlice({
  name: "announcements",

  initialState,
  reducers: {
    setStatus(state, action) {
      const { status } = action.payload;
      state.status = status;
    },
    setSortFilter(state, action) {
      const { sort } = action.payload;
      if (sort === state.sortFilter) {
        state.sortFilter = SORT.STATUS;
      } else {
        state.sortFilter = sort;
      }
    },
    setAnnouncements(state, action) {
      const { announcements } = action.payload;
      state.announcements = announcements;
    },
    setDeatilsFilters(state, action) {
      const { deatilsFilters } = action.payload;
      state.deatilsFilters = deatilsFilters;
    },
    setFilterStatuses(state, action) {
      const { selectedStatuses } = action.payload;
      state.deatilsFilters = {
        ...state.deatilsFilters,
        statuses: selectedStatuses,
      };
    },
    setFilterRegion(state, action) {
      const { selectedRegion } = action.payload;
      state.deatilsFilters = {
        ...state.deatilsFilters,
        region: selectedRegion,
      };
    },
    setFilterCities(state, action) {
      const { selectedCities } = action.payload;
      state.deatilsFilters = {
        ...state.deatilsFilters,
        cities: selectedCities,
      };
    },
    setFilterBeneficiaries(state, action) {
      const { selectedBeneficiary } = action.payload;
      state.deatilsFilters = {
        ...state.deatilsFilters,
        beneficiaries: selectedBeneficiary,
      };
    },
    setFilterOugoings(state, action) {
      const { selectedOutgoing } = action.payload;
      state.deatilsFilters = {
        ...state.deatilsFilters,
        outgoings: selectedOutgoing,
      };
    },
    setFilterSectors(state, action) {
      const { selectedSector } = action.payload;
      state.deatilsFilters = {
        ...state.deatilsFilters,
        sectors: selectedSector,
      };
    },
    clearState(state) {
      state.deatilsFilters = {
        region: {},
        cities: [],
        statuses: [],
        beneficiaries: [],
        outgoings: [],
        sectors: [],
      };
      state.status = Status.IDLE;
      state.announcements = [];
      state.focusedAnnouncement = undefined;
      state.sortFilter = SORT.STATUS;
    },
  },
  extraReducers: {
    [searchAnnouncements.pending](state) {
      state.status = Status.FETCHING;
    },

    [searchAnnouncements.fulfilled](state, action) {
      const { announcementResponse } = action.payload;
      state.status = Status.FOUND;
      state.announcements = announcementResponse;
    },

    [searchAnnouncements.rejected](state) {
      state.status = Status.FAILED;
    },
    [fetchAnnouncements.pending](state) {
      state.status = Status.FETCHING;
    },

    [fetchAnnouncements.fulfilled](state, action) {
      const { announcementResponse } = action.payload;
      state.status = Status.FOUND;
      state.announcements = announcementResponse;
    },

    [fetchAnnouncements.rejected](state) {
      state.status = Status.FAILED;
    },
  },
});

export default slice.reducer;

export const {
  setStatus,
  setFilterStatuses,
  setFilterBeneficiaries,
  setFilterOugoings,
  setFilterSectors,
  setFilterCities,
  setFilterRegion,
  setAnnouncements,
  setDeatilsFilters,
  setSortFilter,
  clearState,
} = slice.actions;

export const selectStatus = (state) => state.announcements.status;

export const selectAnnouncements = (state) => state.announcements.announcements;

export const selectDetailsFilters = (state) =>
  state.announcements.deatilsFilters;

export const selecSortFilter = (state) => state.announcements.sortFilter;
